<template>
    <div class="about-au">
        <p class="indent">Alcomet AD è il più grande produttore bulgaro di laminati ed estrusi in alluminio. L'azienda offre un'ampia gamma di prodotti semilavorati – foglio sottile per alimenti e per vaschette, foglio tecnico, finstock, lamiere; profili standard e personalizzati. Il 95% della produzione totale viene esportato, principalmente in Europa e negli Stati Uniti.</p>
        <p class="indent">L'azienda investe continuamente nell'acquisizione di nuove tecnologie e nell'adeguamento degli impianti esistenti ai più recenti standard tecnologici per soddisfare le richieste più impegnative dei propri clienti ed entrare in nuovi mercati. L'ultimo programma di investimenti, della durata di tre anni, raddoppierà la capacità produttiva ed espanderà gli impianti di produzione di ulteriori 13.000 m2 dopo il suo completamento nel 2019. Per quanto riguarda gli impianti di laminazione, entrerà in funzione un nuovo laminatoio a freddo a 6 –high  con larghezza massima di 2.200 mm, una linea di colata continua, impianti di trattamento termico e linee di finitura, mentre per quanto riguarda l'estrusione una pressa di estrusione  di nuova generazione da 25 MN HybrEx® che consentirà ad Alcomet di estrudere profili con un CCD fino a 310 mm e spessore della parete fino a 0,8 mm.</p>
        <p class="indent">Investendo nelle più moderne attrezzature disponibili, l'azienda si rivolge a nuovi mercati per prodotti ad alto valore aggiunto, come l'edilizia e l'architettura, l'imballaggio flessibile e l’industria automobilistica.</p>
        <div class="about-au-img">
            <img v-scroll-reveal.reset src="/static/img/about/au/1.jpg" alt="">
            <img v-scroll-reveal.reset="{ delay: 250 }" src="/static/img/about/au/2.jpg" alt="">
            <img v-scroll-reveal.reset="{ delay: 500 }" src="/static/img/about/au/3.jpg" alt="">
            <p v-scroll-reveal.reset="{ delay: 750 }" class="about-au-img-p">Alcomet è oggi tra le prime 100 aziende bulgare in termini di fatturato e crescita. È anche tra le prime 100 maggiori imprese per offerta di lavoro in Bulgaria.</p>
        </div>
        <p class="indent">Alcomet è certificata ISO 9001:2015, ISO 14001:2015, BS OHSAS 18001:2007 e EN 15088:2005, ed è fortemente impegnata in programmi che affrontano efficacemente i temi della protezione ambientale, della riduzione dei rifiuti e dell'efficienza delle risorse. Il continuo investimento in tecnologie e attrezzature moderne garantisce il miglioramento dei prodotti e lo sviluppo sostenibile dell'azienda.</p>
        <iframe width="560" height="500" src="https://www.youtube.com/embed/JqQxWslwD8Y" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        <app-share-button></app-share-button>
    </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
export default {
  components: {
    appShareButton: ShareButton
  }
};
</script>

<style scoped>
.about-au p {
  font-size: 19px;
  line-height: 32px;
  margin: 15px auto;
  text-align: justify;
  width: 60%;
}
.about-au-img {
  align-items: center;
  display: flex;
  margin: 40px auto;
  position: relative;
  width: 80%;
  padding-right: 10%;
}
.about-au-img img {
  border-radius: 6px;
  height: auto;
  margin-left: 22px;
  width: calc(33.33% - 22px);
}
.about-au img:last-child {
  padding-right: 0;
}
.about-au-img-p {
  align-items: center;
  background-color: rgba(255, 255, 255, 0.85);
  display: flex;
  font-size: 24px;
  font-weight: 700;
  height: 170px;
  justify-content: center !important;
  text-align: center !important;
  padding: 20px 20px 20px 60px;
  position: absolute;
  right: 0;
  top: calc(50% - 85px);
}
iframe {
  display: block;
  margin: 0 auto;
  width: 60%;
}
@media screen and (max-width: 1280px) {
  .about-au .about-au-img-p {
    font-size: 16px;
  }
}
@media screen and (max-width: 1000px) {
  .about-au p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .about-au-img {
    flex-wrap: wrap;
    margin-bottom: 0;
    padding: 0 30px;
    width: 100%;
  }
  .about-au-img img {
    margin-left: 20px;
    width: calc(33.33% - 13.33px);
  }
  .about-au-img img:first-child {
    margin-left: 0;
  }
  .about-au .about-au-img-p {
    font-size: 12px;
    font-weight: 500;
    height: initial;
    line-height: 20px;
    position: static;
    top: initial;
  }
  iframe {
    width: 100%;
    padding: 10px 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/about/AboutUs.vue